import React, {useEffect, useState, useRef} from 'react';
import {Box, useDimensions} from '@chakra-ui/react';
import InsightsHero from './Insights/Components/hero';
import Podcasts from './Insights/Components/Podcasts';
import axios from "axios";
import {SEO} from "../components/SEO";
import FullCrossPlus from '../components/FullCrossPlus';

const InsightsPage = () => {
    const [insightsData, setInsightsData] = useState(undefined)
    const pageRef = useRef();

    const dimen = useDimensions(pageRef, true);

    const count = Math.floor(dimen?.contentBox.height / 393) + 1 || 0;

    const isMobile = dimen?.contentBox.width < 768;

    useEffect(() => {
        const abortController = new AbortController();
        const fetchInsightsData = async () => {
            const insights = await axios.get(`/wp-json/wp/v2/posts?_embed&acf_format=standard&slug=insights`, {signal: abortController.signal}).then(resp => {
                return resp.data[0];
            });
            setInsightsData(insights)
        }
        fetchInsightsData()
        return () => {
            abortController.abort();
        }
    }, [])

    return (
        <Box>
            <SEO
                image={insightsData?.yoast_head_json?.og_image?.length > 0 ? insightsData?.yoast_head_json?.og_image[0]?.url : null}
                title={insightsData?.title?.rendered}
                ogTitle={insightsData?.yoast_head_json?.og_title}
                description={insightsData?.yoast_head_json?.og_description || insightsData?.excerpt?.rendered}
                url={insightsData?.yoast_head_json?.og_url}
                type={insightsData?.yoast_head_json?.og_type}
                siteName={insightsData?.yoast_head_json?.og_site_name}
                robots={`${insightsData?.yoast_head_json?.robots.index}, ${insightsData?.yoast_head_json?.robots.follow}`}
            />
            <Box ref={pageRef} px={['5', '10']}>
                {!isMobile && Array(count)
                    .fill('')
                    .map((_, key) => (
                        <FullCrossPlus index={key + 1} top={393 * (key + 1)} key={key}/>
                    ))}
                <InsightsHero/>
                <Podcasts/>
            </Box>
        </Box>
    );
};

export default InsightsPage;
